import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Tagline from './components/Tagline';
import About from './components/About';
import Services from './components/Services';
import CaseStudies from './components/CaseStudies';
import Testimonials from './components/Testimonials';
import ClientLogos from './components/ClientLogos';
import Contact from './components/Contact';
import { testimonials } from '@/mocks/testimonials';
import { services } from '@/mocks/services';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://biffdigital.com';
const logoUrl = 'https://storage.helloreaddy.io/project_files/8cf86b48-d09c-4ec8-816e-12bbed2b078b/1e3fa9b9-1413-4092-84fc-01303456e9e9_compressed_Biff-Digital-Logo.webp';

/* ── Person (Founder / Expert / Author) Schema ── */
const founderSchema = {
  '@type': 'Person',
  name: 'BIFF Digital Kurucu Ekibi',
  jobTitle: 'Dijital Pazarlama Stratejisti',
  worksFor: {
    '@type': 'Organization',
    name: 'BIFF Digital',
    url: siteUrl,
  },
  description: 'Endüstriyel ve e-ticaret sektörlerinde 5 yıllık deneyime sahip dijital pazarlama ve reklam uzmanı.',
  sameAs: [
    'https://www.linkedin.com/company/biff-digital',
  ],
};

/* ── Organization Schema (Core — homepage) ── */
const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'BIFF Digital',
  alternateName: 'Biff Digital',
  description:
    'BIFF Digital, Ankara merkezli, İstanbul ve İzmir\'de hizmet veren, endüstriyel ve e-ticaret sektörlerine odaklanan tam hizmet bir B2B dijital pazarlama ve reklam ajansıdır.',
  url: siteUrl,
  logo: logoUrl,
  image: logoUrl,
  email: 'info@biffdigital.com',
  telephone: '+905557101968',
  foundingDate: '2021-08-11',
  numberOfEmployees: '10',
  founder: founderSchema,
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Söğütözü Cad. No: 2 Koç Kuleleri C Blok 17',
    addressLocality: 'Çankaya',
    addressRegion: 'Ankara',
    addressCountry: 'TR',
    postalCode: '06530',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 39.92077,
    longitude: 32.85411,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '18:00',
    },
  ],
  sameAs: [
    'https://www.instagram.com/biffdigital',
    'https://www.youtube.com/@Biff-Digital',
    'https://www.linkedin.com/company/biff-digital',
  ],
  areaServed: [
    { '@type': 'City', name: 'Ankara' },
    { '@type': 'City', name: 'İstanbul' },
    { '@type': 'City', name: 'İzmir' },
    { '@type': 'Country', name: 'Turkey' },
  ],
  knowsAbout: [
    'Dijital Pazarlama', 'Marka Konumlandırması', 'Web Tasarım',
    'E-Ticaret', 'B2B Lead Generation', 'İçerik Üretimi', 'Sosyal Medya Yönetimi', 'SEO',
  ],
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5',
    reviewCount: String(testimonials.length),
    bestRating: '5',
    worstRating: '1',
  },
};

/* ── Service Schemas (homepage) ── */
const serviceQuickSchemas = services.map((s) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: s.title,
  provider: {
    '@type': 'Organization',
    name: 'BIFF Digital',
    url: siteUrl,
  },
  description: s.description,
  areaServed: { '@type': 'Country', name: 'Turkey' },
  serviceType: s.title,
}));

/* ── Review Schemas ── */
const reviewSchemas = testimonials.map((t) => ({
  '@context': 'https://schema.org',
  '@type': 'Review',
  author: { '@type': 'Person', name: t.name },
  reviewBody: t.text,
  reviewRating: {
    '@type': 'Rating',
    ratingValue: String(t.rating),
    bestRating: '5',
    worstRating: '1',
  },
  itemReviewed: { '@type': 'Organization', name: 'BIFF Digital', url: siteUrl },
}));

/* ── BreadcrumbList (Homepage) ── */
const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Ana Sayfa', item: siteUrl },
  ],
};

/* ── Speakable Schema ── */
const speakableSchema = {
  '@context': 'https://schema.org',
  '@type': 'SpeakableSpecification',
  cssSelector: ['.speakable-summary'],
};

/* ── Combine Homepage Schemas ── */
const allSchemas = {
  '@context': 'https://schema.org',
  '@graph': [
    organizationSchema,
    ...serviceQuickSchemas,
    ...reviewSchemas,
    breadcrumbSchema,
    speakableSchema,
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(allSchemas) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Tagline />
        <About />
        <Services />
        <CaseStudies />
        <Testimonials />
        <ClientLogos />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}